import { Box, Typography, useTheme } from '@mui/material';
import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import type { Theme } from '@mui/material/styles';
import WarningIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Warning.js';
import { atlasFontTextSm, type AtlasLensTheme } from './atlasLensStyles';
import { resolveAtlasLensColors } from './formFieldSpec';

export interface AtlasLensFormFieldWarningProps {
  message: string;
  id?: string;
}

/** Inline field warning — same layout as error, warning token colour. */
export function AtlasLensFormFieldWarning({ message, id }: AtlasLensFormFieldWarningProps) {
  const theme = useTheme() as Theme & LensTheme;
  const atlasTheme = theme as AtlasLensTheme;
  const { tokens } = theme;
  const { statusWarningContent } = resolveAtlasLensColors(theme);
  const iconSize = tokens.core.spacing['2'].value;

  return (
    <Box
      id={id}
      role="status"
      sx={{
        display: 'flex',
        gap: tokens.core.spacing['0_5'].value,
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <Box
        aria-hidden
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: iconSize,
          height: iconSize,
          flexShrink: 0,
        }}
      >
        <WarningIcon
          variant="filled"
          size="lg"
          style={{
            fontSize: iconSize,
            color: statusWarningContent,
          }}
        />
      </Box>
      <Typography
        sx={{
          ...atlasFontTextSm(atlasTheme),
          color: statusWarningContent,
          flex: 1,
          minWidth: 0,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}
